import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cc9c86f"
import script from "./legalEntityListVset.js?vue&type=script&lang=js&external"
export * from "./legalEntityListVset.js?vue&type=script&lang=js&external"
import style0 from "./legalEntityListVset.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports